import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { Suspense } from 'react';
import { useEPDataConfig } from './EPDataGrid.config';

const EPDataGrid = () => {
  const { config, data, loading } = useEPDataConfig();
  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default EPDataGrid;
